import generateCSVFromArray from 'generate-csv-from-array'
import { type configuration } from './TableList'
import * as XLSX from 'xlsx'

export function exportCsv<T>(
  exportType: string,
  items: T[],
  configurations: {
    [property in keyof T]: configuration
  },
  getUniqueKey: (t: T) => string
) {
  const localizedHeaders = getHeaders(configurations)

  // get csv data
  const csv = generateCSVFromArray(
    getCsvExportItems(items, configurations, getUniqueKey),
    Object.keys(localizedHeaders).map((property) => [
      localizedHeaders[property],
      property,
    ])
  )

  // download file
  const filename = `export-${exportType}-${filenameSafeDate()}.csv`
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
  )
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

export function exportExcel<T>(
  exportType: string,
  items: T[],
  configurations: {
    [property in keyof T]: configuration
  },
  getUniqueKey: (t: T) => string
) {
  const localizedHeaders = getHeaders(configurations)

  const exportItems = getExcelExportItems(items, configurations, getUniqueKey)
  const excelData: Array<Array<string | Date | number | undefined>> = []
  const headerRow: Array<string | Date | number | undefined> = []
  for (const property of Object.keys(localizedHeaders)) {
    headerRow.push(property)
  }
  excelData.push(headerRow)
  for (const exportItem of exportItems) {
    const excelRow: Array<string | Date | number | undefined> = []
    for (const property of Object.keys(localizedHeaders)) {
      excelRow.push(exportItem[property])
    }
    excelData.push(excelRow)
  }

  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.aoa_to_sheet(excelData, { cellDates: true })
  XLSX.utils.book_append_sheet(workbook, worksheet, exportType)

  // download file
  const filename = `export-${exportType}-${filenameSafeDate()}.xlsx`

  XLSX.writeFile(workbook, filename, {})
  // const element = document.createElement('a')
  // element.setAttribute(
  //   'href',
  //   'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
  // )
  // element.setAttribute('download', filename)

  // element.style.display = 'none'
  // document.body.appendChild(element)

  // element.click()

  // document.body.removeChild(element)
}

function filenameSafeDate() {
  return new Date().toISOString().replaceAll(':', '-').replaceAll('.', '_')
}

function getCsvExportItems<T>(
  items: T[],
  configurations: {
    [property in keyof T]: configuration
  },
  getUniqueKey: (t: T) => string
) {
  const exportItems: Array<Record<string, string | undefined>> = []
  for (const item of items) {
    const row: Record<string, string | undefined> = {}
    for (const property in configurations) {
      const configuration = (configurations as Record<string, configuration>)[
        property
      ]
      const uniqueKey = getUniqueKey(item)
      if (configuration.getCsvExportValue !== false) {
        if (configuration.getCsvExportValue == null) {
          row[property] = item[property] as string
        } else {
          row[property] = configuration.getCsvExportValue(
            item[property],
            uniqueKey
          )
        }
      }
    }
    exportItems.push(row)
  }

  return exportItems
}
function getExcelExportItems<T>(
  items: T[],
  configurations: {
    [property in keyof T]: configuration
  },
  getUniqueKey: (t: T) => string
) {
  const exportItems: Array<Record<string, string | Date | number | undefined>> =
    []
  for (const item of items) {
    const row: Record<string, string | Date | number | undefined> = {}
    for (const property in configurations) {
      const configuration = (configurations as Record<string, configuration>)[
        property
      ]
      const uniqueKey = getUniqueKey(item)
      if (configuration.getExcelExportValue !== false) {
        if (configuration.getExcelExportValue == null) {
          if (typeof item[property] === 'object')
            row[property] = JSON.stringify(item[property])
          else row[property] = item[property] as string
        } else {
          row[property] = configuration.getExcelExportValue(
            item[property],
            uniqueKey
          )
        }
      }
    }
    exportItems.push(row)
  }

  return exportItems
}

function getHeaders<T>(configurations: {
  [property in keyof T]: configuration
}) {
  const localizedHeaders: Record<string, string> = {}

  for (const property in configurations) {
    const configuration = (configurations as Record<string, configuration>)[
      property
    ]
    if (configuration.getCsvExportValue !== false) {
      localizedHeaders[property] = property
    }
  }

  return localizedHeaders
}
